'use client'

import { usePathname } from 'next/navigation'
import { formatDateNormal, formatImageURL } from '@/utils/util'
import { getReadingTime, getExcerpt } from '@/utils/blog'
import { navigateUrl } from '@/utils/client-request'

type Size = 'default' | 'compact'

export default function BlogCard({ blog, index = 0, size = 'default' }: { blog: any, index?: number, size?: Size }) {
  const pathname = usePathname()
  const compact = size === 'compact'
  const href = navigateUrl(`/blog/${blog.id}`, pathname)
  const excerpt = getExcerpt(blog.content, compact ? 100 : 140)
  const reading = getReadingTime(blog.content)
  const category = blog.category?.name || blog.category || ''

  return (
    <a
      href={href}
      className="group block cursor-pointer"
    >
      <div
        className="relative rounded-2xl overflow-hidden aspect-4/3"
        style={{ background: 'rgba(255,255,255,0.035)', border: '1px solid rgba(255,255,255,0.07)' }}
      >
        <img
          src={formatImageURL(blog.thumbnail || 'placeholder.png')}
          alt={blog.title}
          className="absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-out will-change-transform group-hover:scale-105"
        />
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0.4) 0%, transparent 35%, transparent 65%, rgba(0,0,0,0.5) 100%)' }} />
        {category && (
          <div className="absolute top-3 left-3">
            <span
              className="text-[10px] font-semibold uppercase tracking-[0.18em] px-2.5 py-1 rounded-full backdrop-blur-md inline-block"
              style={{ background: 'rgba(0,0,0,0.5)', color: 'white', border: '1px solid rgba(255,255,255,0.18)' }}
            >
              {category}
            </span>
          </div>
        )}
      </div>
      <div className="mt-4">
        <div
          className="font-semibold tracking-[-0.01em] leading-tight line-clamp-2"
          style={{ fontFamily: 'Gilroy, Inter, sans-serif', color: 'white', fontSize: compact ? 17 : 20 }}
        >
          {blog.title}
        </div>
        {!compact && excerpt && (
          <p className="mt-2 text-[13px] leading-6 line-clamp-2" style={{ color: 'rgba(255,255,255,0.6)' }}>
            {excerpt}
          </p>
        )}
        <div className="mt-3 flex items-center gap-2 text-[11px]" style={{ color: 'rgba(255,255,255,0.6)' }}>
          <span className="tabular-nums">{formatDateNormal(new Date(blog.createdAt))}</span>
          {reading > 0 && (
            <>
              <span style={{ opacity: 0.5 }}>·</span>
              <span className="tabular-nums">{reading} мин</span>
            </>
          )}
        </div>
      </div>
    </a>
  )
}
